var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 71,
    viewBox: "0 0 80 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.3398 45.4986C76.9912 45.2191 76.6275 44.9603 76.25 44.723V0H20V39.4922C19.0273 40.1695 18.6861 40.503 16.7719 42.1875H0V70.3125H17.6562H20H53.5977L80 49.7177C79.6105 48.0484 78.677 46.5708 77.3398 45.4986ZM15.3125 65.625H4.6875V46.875H15.3125V65.625ZM43.4375 4.6875H52.8125V18.75H43.4375V4.6875ZM38.75 4.6875V23.4375H57.5V4.6875H71.5625V43.03C68.7553 42.6514 65.9333 43.2916 63.5522 44.8598L56.3414 49.6098C57.0836 48.0725 57.5 46.3495 57.5 44.5312V42.1875H42.8625C41.7841 42.1875 41.3077 41.5973 40.2133 40.6345C35.8636 36.8067 29.9586 35.6775 24.6875 37.2391V4.6875H38.75ZM52.0273 65.625H20V45.5908L21.6333 44.1534C26.0467 40.2695 32.7033 40.2695 37.1167 44.1534C38.3162 45.2089 39.8809 46.8436 42.8625 46.8436H52.4108C51.4436 49.5719 48.8369 51.5623 45.7811 51.5623H36.4061V56.2498H54.7817L66.1306 48.7741C68.652 47.1134 71.8242 47.2641 74.1322 48.9417L52.0273 65.625Z",
    fill: "#384336"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.aba087795862dbf7948a04a09e3b8cc2.svg";
export { ForwardRef as ReactComponent };